/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicenseRespose } from '../../models/license-respose';

export interface AuthLicenseCheck$Params {
}

export function authLicenseCheck(http: HttpClient, rootUrl: string, params?: AuthLicenseCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseRespose>> {
  const rb = new RequestBuilder(rootUrl, authLicenseCheck.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LicenseRespose>;
    })
  );
}

authLicenseCheck.PATH = '/Auth/licenseCheck';
